import React from 'react';
import { Link } from 'react-router-dom';
import qs from 'qs'
import { connect } from 'react-redux';
import { userService } from '../../_services';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/flip.css';

class ResetPasswordPage extends React.Component
{
    constructor(props){
        super(props); 

        this.state ={
            code : '' , 
            password : '' , 
            email : '' , 
            confirmpassword : '' , 
            disableSubmit : false ,
            isConfirmed : false 
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event){
        this.setState ({
            [event.target.name] : event.target.value  //update state of corresponding input name 
        })
    }

    handleSubmit(event){
        event.preventDefault();
        
        if(this.state.password != this.state.confirmpassword){
            
            Alert.error("Password and Confirm password does not match", {
                position: 'bottom-right' , 
                effect : 'flip'
            });

            return false;
        }

        this.setState({
            disableSubmit : true
        });

        userService.resetPassword(this.state);
    }

    componentDidMount(){
        const values = qs.parse(this.props.location.search , { ignoreQueryPrefix: true });

        this.setState({
            code : values.code , 
            email : values.email 
        })
    }

    render(){
        const {loading , alert } = this.props;
        const {password , confirmpassword} = this.state;

        const disableSubmit = this.state.disableSubmit ? 'disabled' : '' ; 

        return (
            <div>
                <div className="columns">
                    <div className="column is-6">
                        <h3 className="title">Reset Password</h3>
                    </div>
                </div>
                
                <form onSubmit={this.handleSubmit}>
                    <div className="field">
                        <div className="control m-t-md">
                            <div className="control-label">Password</div>
                            <input className="input" name="password" type="password" value={password} placeholder="" onChange={this.handleChange} 
                                required pattern=".{8,}" title="Password has to be 8 characters minimum"
                            />
                        </div>
                        <div className="control m-t-md">
                            <div className="control-label">Confirm Password</div>
                            <input className="input" name="confirmpassword" type="password" value={confirmpassword} placeholder="" onChange={this.handleChange} 
                                required pattern=".{8,}" title="Password has to be 8 characters minimum"
                            />
                        </div>
                        <div className="control m-t-lg">
                            <input type="submit" disabled={disableSubmit} className="button button-submit"/>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { loading , alert } = state;
    return {
        loading , alert
    };
}

const connected = connect(mapStateToProps)(ResetPasswordPage);
export { connected as ResetPasswordPage }; 



// WEBPACK FOOTER //
// ./src/Views/ResetPasswordPage/ResetPasswordPage.jsx